import { assets } from '@/ui/assets'
import { InternalLink } from '@/ui/atoms/link/Link'
import { MenuItem } from '@/ui/atoms/menu-item/MenuItem'

interface TopbarMenuPointsItemProps {
  closeMenu: () => void
}

export function TopbarMenuPointsItem({ closeMenu }: TopbarMenuPointsItemProps) {
  return (
    <MenuItem asChild variant="secondary" className="cursor-pointer rounded-none p-6" withSeparator onClick={closeMenu}>
      <InternalLink to="/points/{-$referralCode}" variant="unstyled">
        <img src={assets.points.pointsIcon} alt="Points icon" className="icon-size-sm" />
        Points
      </InternalLink>
    </MenuItem>
  )
}
